module.exports = "https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-page/register/taxi_99.d6f50300.png";